














































































































































































import { computed, defineComponent, ref } from "@vue/composition-api";
import { AppointmentType } from "@scrile/api-provider/dist/projects/scrileConnect/AppointmentTypeProvider";
import {
  AvailabilityIntervalType,
  UserAvailabilityInterval,
} from "@scrile/api-provider/dist/projects/scrileConnect/UserAvailabilityProvider";
import { StepData } from "@/types";
import AppointmentAvailabilitySettings from "@/components/AppointmentAvailabilitySettings";
import AppointmentTypesSettings from "@/components/AppointmentTypesSettings";
import BaseAvatar from "@/components/BaseAvatar";
import BaseButton from "@/components/BaseButton";
import BaseCheckbox from "@/components/BaseCheckbox";
import BaseIcon from "@/components/BaseIcon";
import BasePage from "@/components/BasePage";
import BaseStepper from "@/components/BaseStepper";
import PageTitle from "@/components/PageTitle";

const TYPES_SETTINGS = "typesSettings";
const AVAILABILITY_SETTINGS = "availabilitySettings";

export default defineComponent({
  name: "AppointmentOnboardingView",
  props: {
    offline: { type: Boolean, default: false },
  },
  components: {
    BaseAvatar,
    PageTitle,
    BaseButton,
    BasePage,
    BaseIcon,
    BaseCheckbox,
    BaseStepper,
    AppointmentTypesSettings,
    AppointmentAvailabilitySettings,
  },
  setup(_, { root }) {
    const current = ref(0);
    const loading = ref(false);
    const offlineSettings = ref(false);
    const onlineSettings = ref(false);
    const showChooseType = ref(true);
    const submits: Record<string, (data: any) => Promise<any>> = {};
    const appointmentData: Record<string, string | AppointmentType[] | UserAvailabilityInterval[]> = {};

    const validateState = ref({
      typesSettings: false,
      availabilitySettings: false,
      offlineTypesSettings: false,
      offlineAvailabilitySettings: false,
    });

    const steps = computed<Record<string, StepData & { type: AvailabilityIntervalType }>>(() => ({
      ...(onlineSettings.value && {
        typesSettings: {
          step: 1,
          type: AvailabilityIntervalType.ONLINE,
        },
        availabilitySettings: {
          step: 2,
          type: AvailabilityIntervalType.ONLINE,
        },
      }),
      ...(offlineSettings.value && {
        offlineTypesSettings: {
          step: onlineSettings.value ? 3 : 1,
          type: AvailabilityIntervalType.TOUR_GUIDE,
        },
        offlineAvailabilitySettings: {
          step: onlineSettings.value ? 4 : 2,
          type: AvailabilityIntervalType.TOUR_GUIDE,
        },
      }),
    }));

    const currentStep = (step: number) => "step-" + step;

    const stepsCount = computed(() => {
      return Math.max(...Object.values(steps.value).map(i => i.step));
    });

    const valid = computed(() => {
      if (onlineSettings.value) {
        return current.value === 1 ? validateState.value.typesSettings : validateState.value.availabilitySettings;
      }
      if (!onlineSettings.value && offlineSettings.value) {
        return current.value === 1
          ? validateState.value.offlineTypesSettings
          : validateState.value.offlineAvailabilitySettings;
      }
    });

    const clickChooseType = () => {
      showChooseType.value = false;
      current.value = 1;
    };

    const setCb = (stepName: string, cb: (data: any) => Promise<any>) => {
      submits[stepName] = cb;
    };

    const setData = (stepName: string, data: AppointmentType[] | UserAvailabilityInterval[]) => {
      appointmentData[stepName] = data;
    };

    const createRequestData = () => {
      const data: {
        [TYPES_SETTINGS]: (AppointmentType | UserAvailabilityInterval)[];
        [AVAILABILITY_SETTINGS]: (AppointmentType | UserAvailabilityInterval)[];
      } = {
        [TYPES_SETTINGS]: [],
        [AVAILABILITY_SETTINGS]: [],
      };
      Object.keys(appointmentData).forEach(key => {
        if (["onlineTypes", "offlineTypes"].includes(key)) {
          data[TYPES_SETTINGS] = data[TYPES_SETTINGS].concat(
            appointmentData[key] as (AppointmentType | UserAvailabilityInterval)[]
          );
        }
        if (["offlineAvailability", "onlineAvailability"].includes(key)) {
          data[AVAILABILITY_SETTINGS] = data[AVAILABILITY_SETTINGS].concat(
            appointmentData[key] as (AppointmentType | UserAvailabilityInterval)[]
          );
        }
      });
      return data;
    };

    const saveData = async () => {
      const reqData = createRequestData();
      for (const step of Object.keys(submits)) {
        await submits[step](reqData[step as keyof typeof reqData]);
      }
    };

    const handleButtonClick = async (hasNext: boolean) => {
      if (hasNext) {
        current.value = current.value + 1;
      } else {
        try {
          loading.value = true;
          await saveData();
          root.$router.replace({ name: "appointments", query: { tab: "requests" } });
        } finally {
          loading.value = false;
        }
      }
    };

    const handleTitleClick = () => {
      if (current.value === 1) {
        current.value = 0;
        showChooseType.value = true;
      } else {
        current.value = current.value - 1;
      }
    };

    return {
      TYPES_SETTINGS,
      AVAILABILITY_SETTINGS,
      current,
      loading,
      valid,
      steps,
      offlineSettings,
      onlineSettings,
      showChooseType,
      validateState,
      stepsCount,
      clickChooseType,
      currentStep,
      setCb,
      setData,
      handleTitleClick,
      handleButtonClick,
    };
  },
});
